import React, { Component } from 'react';
import {Alert, Badge} from 'reactstrap';
import {withRouter} from "react-router-dom";
import { Grid, _ } from 'gridjs-react';

import {Loading, Params, Utils} from "custom";
import {AuthAPI, ClientAPI, UserAPI} from "api";
import ClientSetting from "./ClientSetting";

class ClientTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            clients: [],
            clientsFiltered: null,
            alerts: [],
            loading: true,
            error: false
        };

        this.onFilterClients = this.onFilterClients.bind(this);
        this.getClients = this.getClients.bind(this);
        this.resendEmailSignup = this.resendEmailSignup.bind(this);
        this.disconnectUser = this.disconnectUser.bind(this);
    }

    componentDidMount() {
        this.getClients();
    }

    componentWillUnmount() {
        return Params.removeHandlePaginator();
    }

    getClients() {
        this.setState({loading: true});

        ClientAPI.list().then((clients) => {
            let alerts = [];

            for (let i = 0; i < clients.length; i++) {
                if (clients[i].sessions > 5) {
                    alerts.push({
                        name: clients[i].name,
                        sessions: clients[i].sessions
                    });
                }
            }

            this.setState({
                loading: false,
                error: false,
                clients: clients,
                clientsFiltered: null,
                alerts: alerts
            });

            setTimeout(() => {
                Params.addHandlePaginator();
            }, 1000);
        }).catch((err) => {
            console.error(err);
            this.setState({error: true, loading: false});
        });
    }

    onFilterClients(filterConsulent, filterUserActive, filterClassroomActive) {
        let clients = [...this.state.clients];

        if (filterConsulent !== null) {
            if (filterConsulent.value === -1) {
                clients = clients.filter((c) => c.consulent === null);
            } else {
                clients = clients.filter((c) => c.consulent?.id === filterConsulent.value);
            }
        }

        if (filterUserActive !== null) {
            clients = clients.filter((c) => c.active === filterUserActive.value);
        }

        if (filterClassroomActive !== null) {
            clients = clients.filter((c) => c.classroomActive === filterClassroomActive.value);
        }

        if (
            filterConsulent === null &&
            filterUserActive === null &&
            filterClassroomActive === null
        ) {
            this.setState({clientsFiltered: null});
        } else {
            this.setState({clientsFiltered: clients});
        }

        setTimeout(() => {
            Params.addHandlePaginator();
        }, 300);
    }

    resendEmailSignup(id) {
        const self = this;

        global.SweetAlert.fire({
            title: 'Vuoi reinviare la mail di registrazione?',
            text: "Stai per reinviare una mail all'utente con il link per la registrazione, vuoi procedere?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, conferma',
            cancelButtonText: 'Annulla',
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ms-1'
            },
            buttonsStyling: false,
            showLoaderOnConfirm: true,
            preConfirm: function() {
                return new Promise(function(resolve, reject) {
                    UserAPI.resendSignup(id).then(() => {
                        resolve();
                    }).catch(() => {
                        global.SweetAlert.fire({
                            icon: 'error',
                            title: 'Si è verificato un errore :(',
                            text: 'Purtroppo qualcosa è andato storto e non è stato possibile inviare nuovamente il codice di registrazione. Riprova più tardi.',
                            customClass: {
                                confirmButton: 'btn btn-success'
                            }
                        });
                        reject();
                    });
                });
            },
        }).then(function (result) {
            if (result.value) {
                global.SweetAlert.fire({
                    icon: 'success',
                    title: 'Email registrazione inviata!',
                    text: 'È stata inviata la mail di registrazione all\'utente.',
                    customClass: {
                        confirmButton: 'btn btn-success'
                    }
                });
                self.getClients();
            }
        });
    }

    disconnectUser(id, sessions) {
        if (sessions === 0)
            return;

        const self = this;

        global.SweetAlert.fire({
            title: 'Vuoi eliminare le sessioni attive ?',
            text: "Con questa azione l'utente dovrà rifare login in tutti i dispositivi.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, conferma',
            cancelButtonText: 'Annulla',
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ms-1'
            },
            buttonsStyling: false,
            showLoaderOnConfirm: true,
            preConfirm: function() {
                return new Promise(function(resolve, reject) {
                    AuthAPI.clearSession(id).then(() => {
                        resolve();
                    }).catch(() => {
                        global.SweetAlert.fire({
                            icon: 'error',
                            title: 'Si è verificato un errore :(',
                            text: 'Purtroppo qualcosa è andato storto e non è stato possibile rimuovere le sessioni. Riprova più tardi.',
                            customClass: {
                                confirmButton: 'btn btn-success'
                            }
                        });
                        reject();
                    });
                });
            },
        }).then(function (result) {
            if (result.value) {
                global.SweetAlert.fire({
                    icon: 'success',
                    title: 'Sessioni utente eliminate correttamente!',
                    customClass: {
                        confirmButton: 'btn btn-success'
                    }
                });
                self.getClients();
            }
        });
    }

    renderStatusBadge(client) {
        if (client.active) {
            return <Badge color="success">Attivo</Badge>;
        }

        if (client.isRegistered) {
            return <Badge color="danger">Non Attivo</Badge>;
        }

        return (
            <Badge
                color="warning"
                className="cursor-pointer"
                onClick={() => this.resendEmailSignup(client.id)}
            >
                In attesa registrazione
            </Badge>
        );
    }

    renderNameCell(client) {
        return _(
            <div className="d-flex align-items-center gap-2 text-nowrap">
                <span
                    title={client.classroomActive ? "Classe attiva" : "Classe non attiva"}
                    style={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        display: "inline-block",
                        backgroundColor: client.classroomActive ? "#0ab39c" : "#f06548"
                    }}
                />
                <a
                    href={`/client/${client.id}`}
                    onClick={(e) => {
                        if (e.ctrlKey || e.metaKey || e.button === 1) return;
                        e.preventDefault();
                        this.props.history.push(`/client/${client.id}`);
                    }}
                    className="text-primary"
                    style={{ textDecoration: 'none' }}
                >
                    <b>{client.name}</b>
                </a>
            </div>
        );
    }

    render() {
        const self = this;

        if (this.state.error) {
            return (
                <React.Fragment>
                    <Alert color="danger">
                        Si è verificato un errore durante il recupero della lista clienti.
                    </Alert>
                </React.Fragment>
            );
        }

        const isAdmin = (Utils.getUserData().role === "ADMIN");
        const clients = (this.state.clientsFiltered !== null) ? this.state.clientsFiltered : this.state.clients;

        return (
            <React.Fragment>
                {this.state.loading ? <Loading /> : (
                    <React.Fragment>
                        <ClientSetting onFilterClients={this.onFilterClients} />

                        {this.state.alerts.map((session, i) => {
                            return (
                                <Alert key={i} color="warning">
                                    <b>{session.name}</b> ha <b>{session.sessions}</b> sessioni attive negli ultimi 7 giorni
                                </Alert>
                            );
                        })}

                        <Grid
                            data={clients}
                            columns={[
                                {
                                    id: 'id',
                                    name: '#',
                                    width: "60px",
                                    formatter: (cell) => _(
                                        <div className="text-nowrap text-center">#{cell}</div>
                                    )
                                },
                                {
                                    id: 'country',
                                    name: '',
                                    width: "70px",
                                    formatter: (cell) => _(
                                        <div className="text-center text-nowrap">
                                            <img src={Utils.getFlagByCountry(cell)} width="25" alt={cell} />
                                        </div>
                                    )
                                },
                                {
                                    id: 'name',
                                    name: 'Nome',
                                    formatter: (cell, row) => {
                                        const client = clients.find((c) => c.id === row.cells[0].data);
                                        return this.renderNameCell(client);
                                    }
                                },
                                {
                                    id: 'sessions',
                                    name: "Sessioni",
                                    formatter: (cell, row) => _(
                                        <span className="text-nowrap cursor-pointer">
                                            <Badge color="info" onClick={() => self.disconnectUser(row.cells[0].data, cell)}>
                                                <b>{cell}</b>
                                            </Badge>
                                        </span>
                                    )
                                },
                                {
                                    id: "isRegistered",
                                    hidden: true
                                },
                                {
                                    id: "classroomActive",
                                    hidden: true
                                },
                                isAdmin ? {
                                    id: 'consulent',
                                    name: "Consulente",
                                    formatter: (cell) => _(
                                        <div className="d-flex flex-column text-nowrap">
                                            {(cell !== null) ? `${cell.firstname} ${cell.lastname}` : "N/D"}
                                        </div>
                                    ),
                                } : {
                                    id: 'consulent',
                                    hidden: true
                                },
                                {
                                    id: 'cell',
                                    name: "Cellulare",
                                    formatter: (cell) => _(
                                        <div className="text-nowrap">
                                            {cell ? <a href={"tel:" + cell}>{cell}</a> : "--"}
                                        </div>
                                    )
                                },
                                {
                                    id: 'email',
                                    name: "Email",
                                    formatter: (cell) => _(
                                        <div className="text-nowrap">
                                            {cell ? <a href={"mailto:" + cell} target="_blank" rel="noreferrer">{cell}</a> : "--"}
                                        </div>
                                    )
                                },
                                {
                                    id: 'active',
                                    name: 'Stato',
                                    formatter: (cell, row) => {
                                        const client = clients.find((c) => c.id === row.cells[0].data);
                                        return _(
                                            <span className="text-nowrap">
                                                {this.renderStatusBadge(client)}
                                            </span>
                                        );
                                    }
                                }
                            ]}
                            style={{table: {'white-space': 'nowrap'}}}
                            resizable={true}
                            sort={true}
                            search={{
                                selector: (cell) => {
                                    const raw = JSON.stringify(cell);
                                    return raw + " " + Utils.stripDiacritics(raw);
                                }
                            }}
                            pagination={{ enabled: true, limit: 10, page: Params.getActualPage() }}
                            language={{
                                search: {
                                    placeholder: '🔍 Cerca...'
                                },
                                pagination: {
                                    previous: 'Indietro',
                                    next: 'Avanti',
                                    showing: 'Stai visualizzando da',
                                    results: 'Clienti',
                                    to: 'a',
                                    of: 'di',
                                },
                                noRecordsFound: 'Nessun cliente trovato',
                                error: 'Si è verificato un errore non previsto',
                            }}
                        />
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

export default withRouter(ClientTable);
